import * as Sentry from '@sentry/react';

/**
 * Log a non-fatal error without crashing the application
 */
export default function logError(
  error: any,
  origin: string,
  captureContext?: { [key: string]: any },
): string {
  if (import.meta.env.DEV) {
    console.error(`Logged error: ${error.message}`);
    return 'sentry-disabled-in-dev';
  } else {
    return Sentry.captureException(error, {
      ...captureContext,
      tags: {
        origin,
        ...(captureContext && 'tags' in captureContext
          ? captureContext?.tags
          : {}),
      },
    });
  }
}
